<script>
  import { digitalLoadMethods, digitalLoadComputed, layoutMethods, exportMethods,erpFixMessages, erpUserRolesMethods } from '@/state/helpers';
  import Swal from 'sweetalert2';
  import { required } from "vuelidate/lib/validators";
  import { getModuleAccess } from '@/router/helper.js'

  /**
   * Category Promo component
   */
  export default {
    page: {
      title: "Category Promo",
    },
    data() {
      return {
        title: "Category Promo",
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
        filter: null,
        filterOn: [],
        sortBy: "value",
        sortDesc: false,
        submitted: false,
        fieldsCategory: [
          {
            key: 'action',
            sortable: false
          },
          {
            key: 'category_name',
            sortable: true
          },
          {
            key: 'item_count',
            sortable: true
          },
        ],
        category_name: "",
        category_id:0,
        deleteCategoryName: "",
        itemsCategory: [],
        formExitChecker:"",
        searchValue: {
          searchField: null,
          search: "",
          sort: 'id',
          orderDesc: true,
          service: null
        },
        searchListCategory: [{ text: "Category Name", value: null }],
        eloadServiceOptions: [{ text: "All", value: null }],
        eloadCategoryModule: {
          access: {
            create: true,
            delete: true
          }
        }
      };
    },
    validations:{
      category_name:{required}
    },
    computed: {
      ...digitalLoadComputed,
      ...erpFixMessages,
      rows() {
        return this.itemsCategory.length
      }
    },
    mounted: async function() {
      this.getCatList();
      this.changeTitle({title: 'Category Promo'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'}},
          { text: 'Digital Load', to: { name: 'Digital Load'} },
          { text: 'Category Promo', to: { name: 'Category Promo'} }
        ]
      });
      this.actionNetwork({
          action: "services",
          body: {}
      })
      .then((res) => {
        for(let c of res.rows){
          this.eloadServiceOptions.push({text:c["name"], value:c["id"]})
        }
      }).catch((e)=>{
        console.log("error while setup of parent category option",e);
      });

      // get the module access for checking if user has create, read, update, and/or delete access
      await getModuleAccess('Products', 'eLoad', 'eLoad Category')
      .then((access) => this.eloadCategoryModule.access = access);

    },
    methods: {
      ...layoutMethods,
      ...digitalLoadMethods,
      ...exportMethods,
      ...erpUserRolesMethods,
      async onExport(){
        var self = this;
        await this.onPageUpdate("reset").then(function(){
          console.log("check this:",self.loadCategoryTotalRows);
          if(self.loadCategoryTotalRows == 0){
            Swal.fire("Failed!", self.exportNullPrompt, "warning");
          }else{
            let params = Object.assign(
              self.searchValue,
              {
                module: 'eload_categories',
                email: JSON.parse(localStorage.getItem('userData')).email
              });

            delete params.page;
            delete params.rows;
            
            self.exportReport(params)
              .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
              .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
          }
        });
      },
      async getCatList() {
        await this.getLoadCategoryList({
          page: this.currentPage,
          rows: this.perPage,
          ...this.searchValue
        })
      },
      createEloadCategory() {
        this.submitted = true
        this.$v.$touch();

        if (!this.$v.category_name.$invalid){
          this.actionCategory({
            action: "create",
            body:{categoryName: this.category_name}
          })
          .then(() => {
            this.$alertify.success("Added Successfully");
            this.category_name = ""
            this.$bvModal.hide('bv-modal-create-category')
            this.getCatList()
          })
          .catch(function(error) {
            this.$alertify.error(error);
            console.log(error);
            this.category_name = ""
            this.$bvModal.hide('bv-modal-create-category')
          });
        }
      },
      updateEloadCategory() {
        this.submitted = true
        this.$v.$touch();

        if (!this.$v.category_name.$invalid){
          this.actionCategory({
            action: "update",
            body:{
              categoryName: this.category_name,
              id: this.category_id.toString()
            }
          })
          .then(() => {
            this.$alertify.success("Updated Successfully");
            this.category_name = ""
            this.category_id = 0
            this.$bvModal.hide('bv-modal-update-category')
            this.getCatList()
            return;
          })
          .catch(function(error) {
            console.log(error);
            this.$alertify.error(error);
            this.category_name = ""
            this.category_id = 0
            this.$bvModal.hide('bv-modal-update-category')
            return;
          });
        }
      },
      async deleteEloadCategory(id,name) {
        if (!this.eloadCategoryModule.access.delete) {
          Swal.fire(
            "Access Restricted",
            "You are not allowed to delete a Category.",
            "warning"
          );
        } else {
          Swal.fire({
              title: "Are you sure?",
              text: `Do you really want to delete ${name}? This process cannot be undone.`,
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: "Yes",
              cancelButtonText: 'No'
          }).then((result) => {
            if(result.isConfirmed) {
              this.actionCategory({
                action: "delete",
                body: {
                  id: id
                }
              }).then(() => {
                Swal.fire(
                    "Delete Successful!",
                    `${name} has been deleted.`,
                    "success"
                  );
                this.getCatList();
                
              })
              .catch((error) =>{
                Swal.fire("Delete Failed!", `An Error Occured: ${error}`, "danger");
                console.log(error);
              });
            } else {
              return;
            }
          })
        }
      },
      showUpdateModal(data){
        this.category_id = data.categoryId;
        this.category_name = data.categoryName;
        this.formExitChecker = data.categoryName;
        this.$bvModal.show("bv-modal-update-category")
      },
      leaveform(modal){
          if(JSON.stringify(this.category_name) == JSON.stringify(this.formExitChecker)){
              this.$bvModal.hide(modal)
              this.formExitChecker = ''
              return;
          }
          Swal.fire({
              title: 'Are you sure?',
              text: "you want to leave this page?",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '##804997',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No'
          }).then((result) => {
              if (result.isConfirmed) {
                  this.formExitChecker = ''
                  this.$bvModal.hide(modal)
              }else{
                  return;
              }
          })
      },
      async onPageUpdate(reset = "") {
        if(reset == "reset"){
          this.currentPage = 1
        }
        await this.getCatList()
      },
      async onSearch() {
        this.currentPage = 1
        if (this.searchValue.search) {
          this.searching = true
        } else {
          this.searching = false
        }
        await this.getCatList()
      },
      eloadCategorySort(ctx){
        this.searchValue.sort = ctx.sortBy;
        this.searchValue.orderDesc = ctx.sortDesc;
        console.log(">> sorting",this.searchValue);
        if(this.prev_sort != ctx.sortBy){
          this.prev_sort = ctx.sortBy
          this.currentPage = 1
        }
        this.getCatList();
      },
      onDisplayChange(){
        console.log(this.loadCategoryTotalRows,this.perPage,this.loadCategoryList.length,(this.loadCategoryList.length < this.loadCategoryTotalRows && this.loadCategoryList.length != this.perPage));
        if(
          (this.loadCategoryList.length < this.loadCategoryTotalRows && this.loadCategoryList.length != this.perPage) || // condition for incrementing display per page
          (this.loadCategoryList.length == this.loadCategoryTotalRows && this.perPage < this.loadCategoryList.length) // condition for decreasing display per page
          ){
          this.onPageUpdate('reset')
        }
      },
      editCategory(item){
        console.log(">> EDIT:", item);
        this.$router.push(
          this.$route.query.redirectFrom || {
            name: "E-Load Category Form", params: { id: item.categoryId }
          }
        );
      },
    }
  }
    
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-4 col-sm-4">
                <div class="mt-2">
                  <h5 class="card-title">
                    <span class="fw-normal ms-2"
                      >{{loadCategoryTotalRows}}</span
                    > Record(s)
                  </h5>
                </div>
              </div>
              <!-- end col -->

              <!-- Search and button -->
              <div class="col-md-8 col-sm-8"> 

                <div class="d-flex justify-content-end">
                    <div>
                      <b-button v-b-modal.bv-modal-create-category variant="primary" class="me-2" v-if="false"><i class="uil uil-plus me-1"></i> Add Category Promo</b-button>

                      <router-link v-if="eloadCategoryModule.access.create" :to="{ name: 'E-Load Category Form', params: { id: 0 }}" class="tc-white me-2">
                        <button class="btn btn-primary" >
                            <i class="uil uil-plus me-1"></i> Add Category Promo
                        </button>
                      </router-link>

                      <a class="btn btn-secondary" @click="onPageUpdate()"
                        ><feather
                          type="refresh-ccw"
                          size="16"
                          class="icon nav-icon"
                        ></feather
                        >&nbsp;&nbsp; Refresh</a
                      >
                    </div>
                </div>

                
              </div>

              <div class="col-md-12 col-sm-12">
                 <div class="row mt-4">
                    <div class="col-md-4 ta-right">
                      <b-form-group description="Search Keyword">
                        <form class="d-flex" @submit.prevent="onSearch()">
                          <b-form-group id="input-group-3" label-for="input-3">
                            <b-form-select
                              class="form-select rounded-0 rounded-start shadow-none"
                              style="width: fit-content"
                              id="input-3"
                              v-model="searchValue.searchField"
                              :options="searchListCategory"
                            ></b-form-select>
                          </b-form-group>

                          <b-input-group>
                            <b-form-input
                              class="rounded-0"
                              v-model="searchValue.search"
                            ></b-form-input>
                          </b-input-group>
                        </form>
                      </b-form-group>
                    </div>
                    <div class="col-md-8">
                      <div class="d-flex align-items-start mt-2 mt-md-0 gap-2 mb-3 ta-right">
                        <b-form-group label-for="services" description="Filter by Service">
                          <b-form-select class="form-select rounded-0 rounded-start shadow-none"
                            v-model="searchValue.service"
                            :options="eloadServiceOptions"
                          ></b-form-select>
                        </b-form-group>
                        <div class="d-flex align-items-start mt-2 mt-md-0 gap-2 mb-3 ta-right">
                          <a class="btn btn-primary h-fit" @click="onPageUpdate('reset')">
                            <i class='bx bx-search bx-fw'></i>Search
                          </a>
                          <a
                            href="javascript:void(0);"
                            class="btn btn-primary"
                            @click="onExport"
                          >
                            <i class="uil uil-export me-1"></i>
                            Export
                          </a>
                        </div>
                      </div>
                    </div>

                </div>

              </div> <!-- end of list of filter-->
              <!-- end col -->
            </div>
            <!-- end row -->

            <!-- table responsive -->
            <div class="table-responsive">
              <div class="table align-middle table-nowrap">
                <b-table
                  :items="loadCategoryList"
                  :fields="fieldsCategory"
                  responsive="sm"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter-included-fields="filterOn"
                  @sort-changed="eloadCategorySort"
                >

                  <template #cell(action)="data">
                    <div class="d-flex">
                      <div class="btn-group me-2 mb-2 mb-sm-0" v-if="false">
                        <button type="button" class="btn btn-sm btn-primary" @click="showUpdateModal(data.item)">
                          <i class="bx bx-edit bx-xs bx-fw"></i>
                        </button>
                      </div>

                      <b-button
                          id="show-btn"
                          class="btn btn-sm btn-danger"
                          @click="deleteEloadCategory(data.item.categoryId, data.item.categoryName)"
                          ><i class="bx bx-trash bx-xs bx-fw"></i
                        ></b-button>
                    </div>
                  </template>
                  <template #cell(category_name)="data">
                    <b-link
                      class="fw-medium"
                      @click="editCategory(data.item)"
                      >{{ data.item.categoryName }}</b-link
                    >
                  </template>
                  <template #cell(item_count)="data">
                    <span>{{data.item.itemCount}}</span>
                  </template>
                </b-table>
              </div>
            </div>
            <!-- end table responsive -->
            <div class="row g-0 text-center" v-if="loadCategoryTotalRows == 0">
              <span>No data to display.</span>
            </div>
            <div class="row g-0 text-center text-sm-start" v-if="loadCategoryTotalRows != 0 && loadCategoryTotalRows > 10">
              <!-- end col -->
              <div class="col-sm-12">
                <div class="row">
                  <div class="col">
                    <div class="form-group row pull-left">
                      <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                      <div class="col-sm-6">
                        <b-form-group label-for="display-record">
                          <b-form-select class="form-select shadow-none w-fit"
                            id="display-record"
                            v-model="perPage"
                            :options="pageOptions"
                            @change="onDisplayChange()"
                          ></b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                    <div
                      class="
                        dataTables_paginate
                        paging_simple_numbers
                        float-end
                      "
                      v-if="loadCategoryTotalRows > perPage"
                    >
                      <b-pagination
                        class="pagination-rounded"
                        v-model="currentPage"
                        @input="getCatList()"
                        :total-rows="loadCategoryTotalRows"
                        :per-page="perPage"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>

          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>

    <!-- Create Category -->
    <b-modal id="bv-modal-create-category" title="Add Category Promo" @hidden="category_name=''" size="md" hide-footer hide-header-close>
    
      <form class="px-4 py-3" @submit.prevent="createEloadCategory()">

        <div class="mb-3">
          <label class="form-label"
            >Category Name<span style="color: red">*</span></label
          >
          <input
            type="text"
            class="form-control"
            id="addcontact-name-input"
            v-model="category_name"
            placeholder="Enter Category Name"
            :class="{
              'is-invalid':
                submitted && $v.category_name.$error,
            }"
        
          />
        </div>
          
        <div class="text-end mt-4">
          <b-button
            variant="light"
            class="w-sm"
            @click="leaveform('bv-modal-create-category')"
            >Close</b-button
          >
          <b-button
            type="submit"
            variant="primary"
            class="w-sm ms-2"

            >Add</b-button
          >
        </div>
      </form>

    </b-modal>

    <!-- Update Category -->
    <b-modal id="bv-modal-update-category" title="Add Category Promo" size="md" @hidden="category_name='';actionIndex=-1" hide-footer hide-header-close>
    
      <form class="px-4 py-3" @submit.prevent="updateEloadCategory()">

        <div class="mb-3">
          <label class="form-label"
            >Category Name<span style="color: red">*</span></label
          >
          <input
            type="text"
            class="form-control"
            id="addcontact-name-input"
            v-model="category_name"
            placeholder="Enter Category Name"
            :class="{
              'is-invalid':
                submitted && $v.category_name.$error,
            }"
        
          />
        </div>
          
        <div class="text-end mt-4">
          <b-button
            variant="light"
            class="w-sm"
            @click="leaveform('bv-modal-update-category')"
            >Close</b-button
          >
          <b-button
            type="submit"
            variant="primary"
            class="w-sm ms-2"
            >Update</b-button
          >
        </div>
      </form>

    </b-modal>
    <!-- end row -->
  </div>
</template>